import { type FC, useMemo } from "react";
import type { Option } from "../../types";
import type { InputProps } from "../../DynamicInput";
import { MultiAutocomplete } from "../../shared/MultiAutocomplete";
import { Flag } from "../../../shared/Flag";
import { useGetSortByKey } from "../../../shared/SortByKey";
import { inlineInputStateStyles as inlineInputState } from "./InlineInputState";

type CountryProps = InputProps<string[]> & { options: Option[]; isInline: boolean };

export const CountryMultiSelect: FC<CountryProps> = ({ isInline, options, ...props }) => {
  const sortByKey = useGetSortByKey();
  const sortedOptions = useMemo(() => sortByKey(options, "label"), [options, sortByKey]);

  return (
    <MultiAutocomplete
      {...props}
      options={sortedOptions}
      renderIcon={(_, option) => (option ? <Flag countryCode={option.value} /> : undefined)}
      renderIconOption={option => <Flag countryCode={option.value} />}
      inlineInputStateStyles={isInline ? inlineInputState : undefined}
      chipVariant="entity"
      noOptionsTextKey="DynamicForm.Option.Empty"
      placeholderKey="DynamicForm.Inline.InputPlaceholder"
    />
  );
};
